// extracted by mini-css-extract-plugin
module.exports = {"container":"base__container"};